import React, { Component } from 'react'
import { Link, NavLink, BrowserRouter, useHistory } from "react-router-dom";
import Header from '../Common/Header';

export default class AboutUs extends Component {
  render() {
    return (
      <React.Fragment>
        <Header />
        <section className="aboutusbg">
          <div className="hero-section pb-5">
            <div className="container">
              <div className="hero-container">
                <div className="hero-left">
                  <h1>Welcome to Rozgar</h1>
                  <div className='herotextbox pt-3'>
                    <p>Rozgar.com – India’s leading job portal provides the best assistance in helping businesses and job seekers meet supporting its vision</p>
                    <h4><span className='right'>“</span>Hiring People, <span>Building</span> Companies<span className='left'>”</span></h4>
                    <p>We assist the recruiters, corporate, placement agencies, job seekers, etc. with our hiring related services.</p>
                  </div>
                </div>
                <div className="hero-right d-none d-md-block">
                  <img src="/assets/home/aboutus.png" alt="About Image" />
                </div>
              </div>

            </div>

          </div>
        </section>

        <section>
          <div class="sw_our_newsletter_wrapper">
            <div class="container">
              <div class="row">
                <div class="col-md-7 col-lg-7 col-sm-12 col-xs-12">
                  <div class="sw_nl_heading_wrapper sw_our_news_txt">
                    <i class="flaticon-rocket"></i>
                    <h2>Get Rozgar app link on your mobile</h2>
                    <h6>Get Rozgar app link on your mobile</h6>
                    <div class="prs_newsletter_field">
                      <input type="text" placeholder="Enter mobile number......" />
                      <button type="submit" class="waves-effect waves-light waves-ripple">Get link</button>
                    </div>
                    <div className="mobileappbox">
                      <a target='_blank' href='https://play.google.com/store/apps/details?id=com.app.rozgar'>
                        <img src={'./assets/home/google-app.png'} /></a>
                      <a target='_blank' href='https://apps.apple.com/app/id6445827267'>
                        <img src={'./assets/home/iso-app.png'} /></a>
                    </div>
                  </div>
                </div>
                <div class="col-md-5 col-lg-5 col-sm-12 col-xs-12">
                  <div class="sw_letter_img_wrapper wow  zoomIn  animated" data-wow-duration="1.3s" style={{ visibility: 'visible', animationDuration: '1.3s', animationName: 'zoomIn' }}>
                    <img src={'./assets/home/abt_ltr_img.png'} alt="img" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="secttionLocation">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <ul className="citylocaiton">
                  <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/mumbai"> Jobs in Mumbai City</a></li>
                  <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/delhi"> Jobs in Delhi</a></li>
                  <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/gurugram"> Jobs in Gurugram</a></li>
                  <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/noida"> Jobs in Noida</a></li>
                  <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/chennai"> Jobs in Chennai</a></li>
                  <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/pune"> Jobs in Pune</a></li>
                  <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/hyderabad"> Jobs in Hyderabad</a></li>
                  <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/ahmedabad"> Jobs in Ahmedabad</a></li>
                  <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/lucknow"> Jobs in Lucknow</a></li>
                  <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/chandigarh"> Jobs in Chandigarh</a></li>
                  <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/jammu"> Jobs in Jammu</a></li>
                  <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/udaipur"> Jobs in Udaipur</a></li>
                  <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/bhubaneshwar"> Jobs in Bhubaneshwar</a></li>
                  <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/bhopal"> Jobs in Bhopal</a></li>
                  <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/bareilly"> Jobs in Bareilly</a></li>
                  <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/cuttack"> Jobs in Cuttack</a></li>
                  <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/jhansi"> Jobs in Jhansi</a></li>
                  <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/gaya"> Jobs in Gaya</a></li>
                  <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/patna"> Jobs in Patna</a></li>
                  <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/moradabad"> Jobs in Moradabad</a></li>
                  <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/nicobar"> Jobs in Nicobar</a></li>
                  <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/siliguri"> Jobs in Siliguri</a></li>
                  <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/tirunelveli"> Jobs in Tirunelveli</a></li>
                  <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/thane"> Jobs in Thane</a></li>
                  <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/vadodara"> Jobs in Vadodara</a></li>
                  <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/nashik"> Jobs in Nashik</a></li>
                  <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/manglore"> Jobs in Manglore</a></li>
                  <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/ujjain"> Jobs in Ujjain</a></li>
                  <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/coimbatore"> Jobs in Coimbatore</a></li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        <footer class="footer-area">
          <div class="footer-top footer-top-style">
            <div class="container">
              <div class="row justify-content-between">
                <div class="col-xl-2 col-lg-4 col-md-6 col-sm-6">
                  <div class="footer-link footer-link-style-2">
                    <div class="footer-title footer-title-style2">
                      <h3>Jobs</h3>
                    </div>
                    <div class="item-link">
                      <ul>
                        <li><a href="#">Search jobs</a></li>
                        <li><a href="#">Create Rozgar alert</a></li>
                        <li><a href="#">Register now</a></li>
                        <li><a href="#">Jobs by location</a></li>
                        <li><a href="#">Browse all jobs</a></li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-6 col-sm-6">
                  <div class="footer-link footer-link-style-2">
                    {/* <div class="footer-title footer-title-style2">
                      <h3>&nbsp;</h3>
                    </div> */}
                    <h3>&nbsp;</h3>
                    <div class="item-link pt-3">
                      <ul>
                        <li><a href="#">Jobs by skill</a></li>
                        <li><a href="#">Jobs by designation</a></li>
                        <li><a href="#">Jobs by company</a></li>
                        <li><a href="#">Jobs by category</a></li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="col-xl-2 col-lg-3 col-md-6 col-sm-6">
                  <div class="footer-link footer-link-style-2 min50">
                    <div class="footer-title footer-title-style2">
                      <h3>Freshers Jobs</h3>
                    </div>
                    <div class="item-link">
                      <ul>
                        <li><a href="#">Latest fresher jobs</a></li>
                        <li><a href="#">Students</a></li>
                        <li><a href="#">Institution</a></li>
                        <li><a href="#">Hiring company</a></li>
                        <li><a href="#">Internships</a></li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="col-xl-2 col-lg-3 col-md-6 col-sm-6">
                  <div class="footer-link footer-link-style-2">
                    <div class="footer-title footer-title-style2">
                      <h3>Companies</h3>
                    </div>
                    <div class="item-link">
                      <ul>
                        <li><a href="#">Browse all companies</a></li>
                        <li><a href="#">Top companies</a></li>
                        <li><a href="#">Company reviews</a></li>
                        <li><a href="#">Interview questions</a></li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="col-xl-2 col-lg-3 col-md-6 col-sm-6">
                  <div class="footer-link footer-link-style-2">
                    <div class="footer-title footer-title-style2">
                      <h3>Services</h3>
                    </div>
                    <div class="item-link">
                      <ul>
                        <li><a href="#">Resume Creation</a></li>
                        <li><a href="#">Study abroad</a></li>
                        <li><a href="#">Admissions</a></li>
                        <li><a href="#">Students benefits</a></li>
                        <li><a href="#">Career Astrology</a></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row justify-content-between mt-5">
                <div class="col-xl-2 col-lg-4 col-md-6 col-sm-6">
                  <div class="footer-logo-area footer-logo-area-2">
                    <div class="item-logo">
                      <img src="/assets/home/rozgar.png" width="157" height="40" alt="logo" class="img-fluid" />
                    </div>
                    <div class="footer-contact footer-contact-style-2">
                      <div class="footer-location">
                        <ul>
                          <li class="item-map">
                            <i class="fas fa-map-marker-alt"></i> A-51 Sector 16 Noida, U.P. - 201301
                          </li>
                          <li>
                            <a href="mailto:contact@rozgar.com"><i class="fas fa-envelope"></i> contact@rozgar.com</a>
                          </li>
                          <li>
                            <a href="tel:+9177770 04946"><i class="fas fa-phone-alt"></i> +91 77770 04946</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <h5 className="text-white">Connect with us</h5>
                    <div class="item-social">
                      <ul>
                        <li>
                          <a href="https://www.facebook.com/RozgarGlobal/" target="_blank"><i class="fab fa-facebook-f"></i></a>
                        </li>
                        <li>
                          <a href="https://twitter.com/rozgar_india" target="_blank"><i class="fab fa-twitter"></i></a>
                        </li>
                        <li>
                          <a href="https://www.linkedin.com/company/rozgar" target="_blank"><i class="fab fa-linkedin"></i></a>
                        </li>
                        <li>
                          <a href="https://www.instagram.com/rozgarofficial/?hl=en" target="_blank"><i class="fab fa-instagram"></i></a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-6 col-sm-6">
                  <div class="footer-link footer-link-style-2">
                    <div class="footer-title footer-title-style2">
                      <h3>Quick Links</h3>
                    </div>
                    <div class="item-link">
                      <ul>
                        <li><a href="#">Post a Job</a></li>
                        <li><a href="#">Companies</a></li>
                        <li><a href="#">Log In</a></li>
                        <li><a href="#">Register</a></li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="col-xl-2 col-lg-3 col-md-6 col-sm-6">
                  <div class="footer-link footer-link-style-2 min50">
                    <div class="footer-title footer-title-style2">
                      <h3>Let's begin your search</h3>
                    </div>
                    <div class="item-link">
                      <ul>
                        <li><a href="#">Explore cities</a></li>
                        <li><a href="#">Smart search</a></li>
                        <li><a href="#">Discussion forum</a></li>
                        <li><a href="#">Report an issue</a></li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="col-xl-2 col-lg-3 col-md-6 col-sm-6">
                  <div class="footer-link footer-link-style-2">
                    <div class="footer-title footer-title-style2">
                      <h3>Resource centre</h3>
                    </div>
                    <div class="item-link">
                      <ul>
                        <li><a href="#">About Us</a></li>
                        <li><a href="#">Resume samples</a></li>
                        <li><a href="#">Blog</a></li>
                        <li><a href="#">FAQs</a></li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="col-xl-2 col-lg-3 col-md-6 col-sm-6">
                  <div class="footer-link footer-link-style-2">
                    <div class="footer-title footer-title-style2">
                      <h3>Employer Zone</h3>
                    </div>
                    <div class="item-link">
                      <ul>
                        <li><a href="#">Buy online</a></li>
                        <li><a href="#">Our hiring solutions</a></li>
                        <li><a href="#">Employer login</a></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="footer-bottom footer-bottom-style-2">
            <div class="container">
              <div class="row justify-content-center">
                <div class="col-lg-12 col-md-12 text-center">
                  <div class="copyright-area2">
                    <p>Copyright © 2021-22 Rozgar.com. All Rights Reserved | Powered by <a target='_blank' className="powercom" href="https://www.valueinnovationlabs.com/">Value Innovation Pvt. Ltd.</a></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </React.Fragment>
    )
  }
}
